import compact from 'lodash/compact';
import { ReactElement } from 'react';

import { Gender } from '@dreryk/egabinet-patient-frontend-api';

import { BindingCreator } from '@dreryk/react-common';
import { RadioGroupItem } from '@dreryk/react-components';

import {
   isPatientSpecialModeAvailable,
   isPregnantModeAvailable,
   PatientDataAccessMode,
} from '~libs.shared.prescription';

import { prescriptionsHistoryDownloadTranslationKeys } from '../../../translations';

import { StyledPatientDataAccessFormAccessModeField } from './PatientDataAccessFormAccessModeField.styled';
import { PatientDataAccessFormAccessModeFieldIcon } from './PatientDataAccessFormAccessModeFieldIcon';

export const isSpecialModeAvailable = (patientAge: number): boolean => isPatientSpecialModeAvailable(patientAge);

const useItems = (patientGender: Gender, patientAge: number): RadioGroupItem<PatientDataAccessMode>[] =>
   compact([
      {
         id: 'STANDARD',
         label: prescriptionsHistoryDownloadTranslationKeys.accessMode.standard,
         suffixIcon: (
            <PatientDataAccessFormAccessModeFieldIcon
               tooltipContent={prescriptionsHistoryDownloadTranslationKeys.accessMode.description.standard}
               testId={'standardMode'}
            />
         ),
      },
      isSpecialModeAvailable(patientAge) && {
         id: 'SPECIAL',
         label: prescriptionsHistoryDownloadTranslationKeys.accessMode.special,
         suffixIcon: (
            <PatientDataAccessFormAccessModeFieldIcon
               tooltipContent={prescriptionsHistoryDownloadTranslationKeys.accessMode.description.special}
               testId={'specialMode'}
            />
         ),
      },
      isPregnantModeAvailable(patientGender, patientAge) && {
         id: 'SPECIAL_PREGNANCY',
         label: prescriptionsHistoryDownloadTranslationKeys.accessMode.pregnant,
         suffixIcon: (
            <PatientDataAccessFormAccessModeFieldIcon
               tooltipContent={prescriptionsHistoryDownloadTranslationKeys.accessMode.description.pregnant}
               testId={'specialPregnancyMode'}
            />
         ),
      },
   ]);

type PatientDataAccessFormAccessModeFieldFormBeanPart = {
   accessMode: PatientDataAccessMode;
};

type PatientDataAccessFormAccessModeFieldProps = {
   readonly register: BindingCreator<PatientDataAccessFormAccessModeFieldFormBeanPart, 'accessMode'>;
   readonly patientGender: Gender;
   readonly patientAge: number;
};

export const PatientDataAccessFormAccessModeField = (
   props: PatientDataAccessFormAccessModeFieldProps
): ReactElement => {
   return (
      <StyledPatientDataAccessFormAccessModeField
         testId={'accessMode'}
         items={useItems(props.patientGender, props.patientAge)}
         controller={props.register('accessMode')}
      />
   );
};
